module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-Bold.90aa1ee.woff";